export default "__VITE_ASSET__b65836c9__"